import { render, staticRenderFns } from "./icon-svg.vue?vue&type=template&id=1796a323&"
import script from "./icon-svg.vue?vue&type=script&lang=js&"
export * from "./icon-svg.vue?vue&type=script&lang=js&"
import style0 from "./icon-svg.vue?vue&type=style&index=0&id=1796a323&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports